import { Autocomplete, TextField } from "@mui/material";
import { castArray } from "lodash";
import { CustomFieldInputComponent } from "../CustomFieldsForm";
import { useEffect, useState } from "react";
import { CustomFieldSelectOption } from "../../../../graphql/generated";
import { getCustomFieldOptions } from "./SelectCustomFieldInput";
import { testIds } from "./MultiSelectCustomFieldInput.testIds";

const MultiSelectCustomFieldInput: CustomFieldInputComponent = ({
  value,
  customFieldDefinition,
  onChange,
  disabled,
}) => {
  const [options, setOptions] = useState<CustomFieldSelectOption[]>([]);
  useEffect(() => {
    getCustomFieldOptions(
      customFieldDefinition,
      value
        ? castArray(value).filter(
            (item): item is string => typeof item === "string"
          )
        : []
    ).then(setOptions);
  }, [customFieldDefinition, value]);

  return (
    <Autocomplete data-testid={testIds.multiSelectCustomFieldInputPicker}
      options={options.map((option) => option.key) || []}
      getOptionLabel={(optionKey) =>
        options.find((selectOption) => selectOption.key === optionKey)?.label ||
        ""
      }
      onChange={(event, value) => {
        onChange(value.map(String));
      }}
      multiple
      value={value ? castArray(value) : []}
      size="medium"
      fullWidth
      disabled={disabled}
      renderInput={(inputProps) => (
        <TextField
          label={customFieldDefinition.label}
          {...inputProps}
          inputProps={{ ...inputProps.inputProps, "data-testid": testIds.multiSelectCustomFieldInputSearch }}
        />
      )}
    />
  );
};

export default MultiSelectCustomFieldInput;
